import { Jwt } from '@medicusunion/front-utils';
import { StorageKeys } from '@/constants/storage';
import { refreshTokenStorage, tokenStorage } from '@/utils/storage';
import config from '../config';

const storages = {
  [StorageKeys.token]: tokenStorage,
  [StorageKeys.refreshToken]: refreshTokenStorage
};

type Key = StorageKeys.token | StorageKeys.refreshToken;

export const jwt = new Jwt({
  baseUrl: config.api_url as string,
  tokenKey: StorageKeys.token,
  refreshKey: StorageKeys.refreshToken,
  getFunction: async key => storages[key as Key].getItem(),
  setFunction: async (key, value) => storages[key as Key].setItem(value),
  deleteFunction: async key => storages[key as Key].removeItem()
});
